var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3V1.5h5V3Zm1.75 9.021h1.5v-5h-1.5ZM10 18q-1.458 0-2.729-.552-1.271-.552-2.219-1.5t-1.5-2.219Q3 12.458 3 11q0-1.458.552-2.729.552-1.271 1.5-2.219t2.219-1.5Q8.542 4 10 4q1.208 0 2.323.406t2.073 1.136l1.083-1.063 1.042 1.042-1.063 1.083q.73.938 1.136 2.063Q17 9.792 17 11q0 1.458-.552 2.729-.552 1.271-1.5 2.219t-2.219 1.5Q11.458 18 10 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimer);
export default __webpack_public_path__ + "static/media/icon-timer.6ea50a31674432daf3be2d692348e750.svg";
export { ForwardRef as ReactComponent };